module.exports = __webpack_public_path__ + "img/video-surveillance.9e46e7b6.svg";